import { LanguageStrings } from './base-strings';

export const de: LanguageStrings = {
  /** Routes */
  'routes.home': '/',
  'routes.summary': '/zusammenfassung',

  /** Page content */
  'home.title': 'Zuhause',
  'home.content':
    'Vielen Dank für den Besuch dieses mehrsprachigen Routing-Beispiels.',

  'summary.title': 'Zusammenfassung',
  'summary.content':
    'Lesen Sie mehr über den Artikel selbst auf {medium} oder {devto}.',

  'error.title': 'Error',
  'error.content':
    'Diese Seite hat sich für einen Urlaub entschieden. Versuchen Sie es später noch einmal.',

  /** Links */
  'links.medium':
    'https://medium.com/prototyped/multi-language-routing-in-react-d7eb7a0688e9',
  'links.dev.to': 'https://dev.to/prototyp/multi-language-routing-in-react-k9l'
};
